import { kicqstartGeneArrayRoute } from '@src/routes'

export enum ProductTypes {
  ProductType = 'kicqstartgenearrays',
}

export enum ActiveLinkType {
  searchArray = 'searchArray',
  selectSpecies = 'selectSpecies',
  ReviewAndConfirm = 'reviewAndConfirm',
}

export enum GeneArrayProperties {
  Empty = 'E',
  All = 'All',
  Next = 'Next',
  Previous = 'Previous',
  mixed = 'Mixed',
  custom = 'Custom',
  maximumPlateSize = '25',
  Quote = 'QUOTE',
}

export enum DownloadFile {
  fileName = 'Array Information.xls',
}

export const selectSpeciesPageRoute = `${kicqstartGeneArrayRoute.index()}?activeLink=${
  ActiveLinkType.selectSpecies
}`
export const searchArrayPageRoute = `${kicqstartGeneArrayRoute.index()}?activeLink=${
  ActiveLinkType.searchArray
}`
export const reviewConfirmPageRoute = `${kicqstartGeneArrayRoute.index()}?activeLink=${
  ActiveLinkType.ReviewAndConfirm
}`

export enum PlateProperties {
  geneSymbol = 'geneSymbol',
  sequence = 'sequence',
  geneID = 'geneID',
  selectSpecies = 'selectSpecies',
  SelectedWell = 'SelectedWell',
  SelectedPlate = 'SelectedPlate',
  primerPairId = 'primerPairId',
  Select = 'Select',
  speciesInputParam = 'species:',
  ascendingOrder = 'ASC',
  wellType = 'Plate Type',
  species = 'Species',
}

export enum KSGeneArraysProperties {
  Quote = 'QUOTE',
  Success = 'success',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
}
